export default __webpack_public_path__ + "static/media/phone-download-3x.72d1d1bc.png";